import { AcumaticaService } from './../../acumatica/acumatica.service';
import { CancelActionError } from '../../acumatica/acumatica-errors';
import { Component, isDevMode, AfterViewInit, ViewChild, ElementRef, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Shipment, ShipmentService } from '../../acumatica/EntityServices/Shipment.service';
import { ApplicationScreen } from '../../application-navigator/application-screen';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { AlertDialog } from 'src/app/common/alert-dialog/alert-dialog.component';
import { LoadingIndicator } from 'src/app/acumatica/loading-indicator/AcumaticaLoadingOptions';

@Component({
  selector: 'app-order-picking-get-shipment',
  templateUrl: './order-picking-get-shipment.component.html',
  styleUrls: ['./order-picking-get-shipment.component.css']
})
export class OrderPickingGetShipmentComponent extends ApplicationScreen implements AfterViewInit {
  pageTitle = "Pick Shipment";
  soOrderType?: string;

  @ViewChild('shipmentsListTabGroup') shipmentsListTabGroup!: MatTabGroup;
  get shipmentListTabIndex(): number {
    return parseInt(localStorage.getItem('selected-shipment-list-tab') || '0');
  }
  set shipmentListTabIndex(value: number) {
    this.shipmentsListTabGroup.selectedIndex = value;
  }
  selectedShipmentListTabChanged(event: MatTabChangeEvent) {
    localStorage.setItem('selected-shipment-list-tab', event.index.toString());
  }

  ShipmentTableCols: string[] = ['ShipmentNbr', 'ShipmentDate', 'PickerID'];
  YardageShipments: Shipment[] = [];
  SamplesShipments: Shipment[] = [];

  createSOShipment = new FormGroup({
    soOrderType: new FormControl(null, Validators.required),
    soOrderNbr: new FormControl(
      isDevMode() ? localStorage.getItem('DEV-SO-NBR') : null,
      Validators.required
    )
  });

  loadSOShipment = new FormControl(
    isDevMode() ? localStorage.getItem('DEV-SH-NBR') : null,
    Validators.required
  );

  printShipmentConfirmationNbr = new FormControl(null, Validators.required);

  constructor(
    private router: Router,
    private shipments: ShipmentService,
    private acumatica: AcumaticaService,
    private dialog: MatDialog
  ) {
    super();
  }

  ngAfterViewInit(): void {
    setTimeout(() => (<any>this.loadSOShipment).focus());
  }

  gotoShipment(shipmentNbr: string = this.loadSOShipment.value) {
    if (isDevMode()) localStorage.setItem('DEV-SH-NBR', shipmentNbr);
    this.router.navigate(['/picking', shipmentNbr]);
  }

  onTabChange(event: MatTabChangeEvent) {
    if (event.tab.textLabel == "Print Confirm.") {
      (<any>this.printShipmentConfirmationNbrField.nativeElement).focus();
    }
  }

  // #region Shipment Confirmation print
  @ViewChild('printShipmentConfirmationNbrField') printShipmentConfirmationNbrField!: ElementRef<Input>;
  printShipmentConfirmation(shipmentNbr: string = this.printShipmentConfirmationNbr.value) {
    this.shipments.printShipmentConfirmation(shipmentNbr, { message: "Printing Shipment Confirmation", indicator: LoadingIndicator.snackbar }).then(
      () => {
        this.printShipmentConfirmationNbr.reset();
      },
      err => {
        this.dialog.open(AlertDialog, {
          data: {
            message: err.toString()
          }
        })
      }
    );
  }
  // #endregion

  get soOrderNbr() { return this.createSOShipment.get('soOrderNbr'); }

  getCreateShipmentErrorMessage() {
    if (this.createSOShipment.hasError('invalidOrderNbr')) {
      return "No such Sales Order Number";
    } else if (this.createSOShipment.hasError('inShippingStatus')) {
      return "Sales Order already in Shipping status";
    } else if (this.createSOShipment.hasError('customerCreditHold')) {
      return "Customer is on Credit Hold";
    }

    return '';
  }

  createShipmentError: Error | null = null;
  createShipment() {
    // any FormControls invalid (required field empty) return immediately
    if (!this.createSOShipment.valid) return;

    if (isDevMode()) localStorage.setItem('DEV-SO-NBR', this.createSOShipment.get('soOrderNbr')!.value);
    this.shipments.createShipment(
      this.createSOShipment.get('soOrderType')!.value,
      this.createSOShipment.get('soOrderNbr')!.value
    ).subscribe(shipment => {
      this.gotoShipment(shipment.ShipmentNbr);
    }, (error: Error) => {
      if (error instanceof CancelActionError) {
        (<any>this.soOrderNbr).focus();
      } else {
        console.error(error);
        this.createShipmentError = error;
      }
    })
  }
}
